import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "EditProfile",
    component: () =>
        __SERVER__ ? require("./profile-information-view") : import("./profile-information-view")
});

export default definition;
